import ActionType from 'actions/ActionType'

export default (
  state = { dialogOpen: false, dialogState: 'users', userSelected: null },
  action,
) => {
  switch (action.type) {
    case ActionType.Users.TOGGLE_DIALOG:
      if (typeof action.payload === 'boolean') {
        return {
          ...state,
          dialogOpen: action.payload,
        }
      }

      return {
        ...state,
        dialogOpen: !state.dialogOpen,
      }
    case ActionType.Users.TOGGLE_STATE:
      return {
        ...state,
        dialogState: action.payload
          ? action.payload
          : state.dialogState === 'invites'
          ? 'users'
          : 'invites',
      }
    case ActionType.Users.SELECT_USER:
      return {
        ...state,
        userSelected: action.payload,
      }
    default:
      return state
  }
}
